import { reloadAds } from '@utils/advertisement';
import { articleListedState as state } from './articleListedState';
import {
  activeChapterToInfoBox,
  articleListedToggleChapter as toggleChapter,
} from './articleListedToggleChapter';
import { articleListedLoadButtons as loadButtons } from './articleListedLoadButtons';
import { targetTopScroll } from './articleListedScrollCalc';
import { addChapterUrlParam } from './articleListedChapterUrlParam';
import {
  articlePartPrev,
  articlePartNext,
} from '../../../components/analytics/GoogleTagManager/GTMArticle';
import { pauseAllVideos } from '@utils/pauseAllVideos';

// Znovu načíst aktuální kapitolu
export const reload = () => {
  toggleChapter();

  // Načíst tlačítka
  loadButtons();
  activeChapterToInfoBox();

  // Scroll na začátek článku
  window.scrollTo({
    top: targetTopScroll(),
    behavior: 'smooth',
  });

  // Reloadovat reklamu
  reloadAds();
};

// Návrat na první kapitolu
export const home = () => {
  state.setActiveChapter(1);

  addChapterUrlParam(1);
  activeChapterToInfoBox();

  articlePartPrev(1).then(
    () => {},
    () => {}
  );

  reload();
};

// Další kapitola
export const next = () => {
  // pausa všech videí před přechodem na další kapitolu
  pauseAllVideos();

  // Poslední kapitole | Návrat na první kapitolu
  if (state.getIsLast()) {
    home();
    return;
  }

  state.increaseActiveChapter();

  addChapterUrlParam(state.getActiveChapter());
  activeChapterToInfoBox();

  articlePartNext(state.activeChapter).then(
    () => {},
    () => {}
  );

  reload();
};

// Předchozí kapitola
export const prev = () => {
  // pausa všech videí před přechodem na předchozí kapitolu
  pauseAllVideos();

  // První kapitole | Bez akce
  if (state.activeChapter === 1) {
    return;
  }

  state.decreaseActiveChapter();

  addChapterUrlParam(state.getActiveChapter());
  activeChapterToInfoBox();

  articlePartPrev(state.activeChapter).then(
    () => {},
    () => {}
  );

  reload();
};
